import React from 'react';
import KeyboardBackspaceSharpIcon from '@mui/icons-material/KeyboardBackspaceSharp';
import { Box, Typography } from '@mui/material';

export default function FixedBackButton() {
	return (
		<Box
			sx={{
				// position: 'fixed',
				// top: 0,
				// left: 65,
				height: '10px',
				width: '100%',
				bgcolor: 'white',
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				// p: 2,
				boxShadow: '0 -2px 6px rgba(0,0,0,0.1)',
				zIndex: 1300,
				cursor: 'pointer',
			}}
			onClick={() => window.history.back()}
			aria-label="Go back"
		>
			<KeyboardBackspaceSharpIcon sx={{ color: 'black' }} />
			<Typography>Back</Typography>
		</Box>
	);
}
